import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  Button,
  Form,
  Segment
} from 'semantic-ui-react';

import BaseDateField from '_forms/baseDate'
import BaseNumberField from '_forms/baseNumber'
import BaseSelectField from '_forms/baseSelect';
import BaseInputField from '_forms/baseInput';
import BaseCheckboxGroupField from '_forms/baseCheckboxGroup';

import { LICENSE_POOL_PRODUCTS, LICENSE_POOL_TYPES, SUBLICENSE_DISPLAY_NAMES, SUBLICENSE_OPTIONS_BY_MAX_VERSION } from '../../server/constants';
import { getValue, toTitle } from '_utils';

const CreateLicensePoolForm = ({ onCancel, onSubmit }) => {

  const [formData, setFormData] = useState({
    addons: [],
    name: LICENSE_POOL_PRODUCTS.MAX9,
    type: LICENSE_POOL_TYPES.FULL,
    description: "",
    ac_count: 0,
    key_count: 0,
    ilok_count: 0,
    keyserver_count: 0,
    expires_on: undefined
  });

  const onSubmitForm = () => onSubmit(formData);
  const onChange = (_, data) => {
    const update = { [data.name]: getValue(data) };

    // reset expiry
    if (update.type !== undefined) {
      // Default subscription expiry is 1 month from now
      update.expires_on = update.type === LICENSE_POOL_TYPES.SUBSCRIPTION ? moment().add(1, "month") : undefined;
    }

    // reset addons
    if (update.name !== undefined) {
      update.addons = [];
    }

    setFormData(Object.assign({}, formData, update));
  };

  const addOnOptions = SUBLICENSE_OPTIONS_BY_MAX_VERSION[formData.name].map(id => ({
    label: SUBLICENSE_DISPLAY_NAMES[id],
    value: id
  }));

  return (
    <Segment>
      <Form size='tiny' onSubmit={ onSubmitForm } >
        <Form.Group>
          <BaseSelectField
            width={ 4 }
            name="name"
            popupTxt='What product is the pool for?'
            labelTxt="Product"
            value={ formData.name }
            options={ Object.values(LICENSE_POOL_PRODUCTS).map(v => ({ text: v, value: v })) }
            onChange={ onChange }
          />
          <BaseSelectField
            width={ 4 }
            name="type"
            popupTxt='What type of pool?'
            labelTxt="Type"
            value={ formData.type }
            options={ Object.values(LICENSE_POOL_TYPES).map(v => ({ text: v, value: v })) }
            onChange={ onChange }
          />
          {
            formData.type === LICENSE_POOL_TYPES.SUBSCRIPTION ? (
              <BaseDateField
                width={ 8 }
                name='expires_on'
                value={ moment(formData.expires_on) }
                onChange={ onChange }
                labelTxt='Expires On'
              />
            ) : null
          }
        </Form.Group>
        <Form.Group>
          <BaseInputField
            width={ 16 }
            labelTxt='Description'
            popupTxt='Optional description to identify this license pool. Note that the info here will be visible to 3rd party admins as well.'
            name='description'
            value={ formData.description }
            onChange={ onChange }
          />
        </Form.Group>
        <Form.Group>
          <BaseCheckboxGroupField
            name="addons"
            labelTxt={ addOnOptions.length ? 'Included Add Ons' : `No addons available for ${toTitle(formData.name)}` }
            popupTxt="Include the following add ons in all licenses created from or associated with this pool."
            onChange={ onChange }
            options={ addOnOptions }
            value={ formData.addons }
          />
        </Form.Group>
        <Form.Group>
          <BaseNumberField
            width={ 8 }
            min={ 0 }
            name='ac_count'
            labelTxt='Activation Code Pool'
            popupTxt='How many seats are reserved for Max 8 AC authorizations?'
            value={ formData.ac_count }
            onChange={ onChange }
          />
          <BaseNumberField
            width={ 8 }
            min={ 0 }
            labelTxt='Key Pool'
            popupTxt='How many seats are reserved for Max 8 key authorizations?'
            name='key_count'
            value={ formData.key_count }
            onChange={ onChange }
          />
        </Form.Group>
        <Form.Group>
          <BaseNumberField
            width={ 8 }
            min={ 0 }
            name='ilok_count'
            labelTxt='iLok Pool'
            popupTxt='How many seats are reserved for Max 8 ilok authorizations?'
            value={ formData.ilok_count }
            onChange={ onChange }
          />
          <BaseNumberField
            width={ 8 }
            min={ 0 }
            labelTxt='Keyserver Pool'
            popupTxt='How many seats are reserved for Max 8 keyserver authorizations?'
            name='keyserver_count'
            value={ formData.keyserver_count }
            onChange={ onChange }
          />
        </Form.Group>
        <Form.Group>
          <BaseInputField
            width={ 8 }
            labelTxt='iLok Account Name'
            popupTxt='iLok Account Name for License Pool, if applicable.'
            name='ilok_account_name'
            value={ formData.ilok_account_name }
            onChange={ onChange }
          />
        </Form.Group>
        <Button.Group>
          <Button onClick={ onCancel }>Cancel</Button>
          <Button.Or />
          <Button positive type="submit">Create</Button>
        </Button.Group>
      </Form>
    </Segment>
  )
};

CreateLicensePoolForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default CreateLicensePoolForm;



// WEBPACK FOOTER //
// ./webAdmin/forms/institutionLicensePoolFormCreate.js